import { useState } from "react";
import Compliance from "./pages/Compliance";
import Survey from "./pages/Survey";
import ThankYou from "./pages/ThankYou";
import Error from "./pages/Error";
import Loading from "./pages/Loading";
import GoogleAnalytics from "./components/GoogleAnalytics";
import AppWrapper from "./components/AppWrapper";
import { APP_LAST_UPDATED, APP_VERSION } from "@/version";

// Expose build info
window.appVersion = APP_VERSION;
window.appLastUpdated = APP_LAST_UPDATED;

function App() {
	const [step, setStep] = useState("loading"); // loading, compliance, survey, thankyou, error

	// Expose a function to skip to Thank You page for testing/demo
	window.skipToThankYou = () => setStep("thankyou");

	let content = null;
	if (step === "loading") content = <Loading onComplete={setStep} />;
	else if (step === "thankyou") content = <ThankYou />;
	else if (["invalid", "error"].includes(step)) content = <Error />;
	else if (step === "compliance") content = <Compliance onContinue={() => setStep("survey")} />;
	else if (step === "survey") content = <Survey onFinish={(result) => setStep(result || "thankyou")} />;

	return (
		<>
			<AppWrapper>
				<GoogleAnalytics />
				{content}
			</AppWrapper>
		</>
	);
}

export default App;
